import { trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import { useStateMachineContext } from '@spotahome/landings-common/src/context/StateMachineContext';

import { TENANT_CONFIG_NEW } from '../../constants';

import ContactUsHeader from '../ContactUsHeader';
import './ContactSections.scss';

const ContactSections = () => {
  const { payload, send } = useStateMachineContext();
  const { role, categoryId } = payload;

  const categoryReasons = TENANT_CONFIG_NEW[categoryId] || [];
  const baseLocoKey = `contact-us.${role}.new`;

  const handleItemClick = (sectionId, reasonId) => {
    send('SELECT', { sectionId, reasonId });
  };

  const renderNewFormat = () => (
    <ul className="contact-subcategories__list">
      {categoryReasons.map(reasonId => (
        <li key={reasonId}>
          <Button
            color="primary"
            size="large"
            alt
            fullWidth
            onClick={() => handleItemClick(null, reasonId)}
            className="contact-us-form__button--alt"
            dataTest={`${reasonId}-button`}
          >
            {trans(`${baseLocoKey}.${reasonId}`)}
          </Button>
        </li>
      ))}
    </ul>
  );

  return (
    <div className="contact-us-form__fields">
      <ContactUsHeader
        title={trans(`${baseLocoKey}.${categoryId}`)}
        onBack={() => send('BACK')}
      />
      {renderNewFormat()}
    </div>
  );
};

export default ContactSections;
